/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPageAuthenticationInputItemDetail } from './formPageAuthenticationInputItemDetail';
import { FormPageAuthenticationInputItemAllOf } from './formPageAuthenticationInputItemAllOf';
import { FormPagePropertyItemStringConvertRule } from './formPagePropertyItemStringConvertRule';


/**
 * 認証項目 または、照合項目.
 */
export interface FormPageAuthenticationInputItem { 
    /**
    * フォーム入力項目大種別
    */
    propertyType: 'authentication';
    /**
    * 入力項目ID
    */
    propertyId: string;
    /**
    * 項目名(管理機能のopenapiではdisplay_name）
    */
    name: string;
    /**
    * 項目のコメント(管理機能のopenapiではdisplay_comment）
    */
    comment?: string;
    /**
    * 注意書き・凡例(管理機能のopenapiではcaution）
    */
    note?: string;
    /**
    * 必須/任意のラベルを表示するかどうか.
    */
    displayRequiredLabel: boolean;
    stringConvertRule?: FormPagePropertyItemStringConvertRule;
    type: FormPageAuthenticationInputItem.TypeEnum;
    /**
    * 認証項目（更新キー）であるか
    */
    isUpdateKey: boolean;
    /**
    * 年月日型/月日型の場合に入る
    */
    format?: FormPageAuthenticationInputItem.FormatEnum;
    detail: FormPageAuthenticationInputItemDetail;
}

export namespace FormPageAuthenticationInputItem {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
    export type FormatEnum = 'date';
    export const FormatEnum = {
        Date: 'date' as FormatEnum
    };
}


